import { ElementRef } from '@angular/core';
import { Observable } from 'rxjs';
import { distinctUntilChanged, map, mergeMap } from 'rxjs/operators';

export const createAndObserveIntersection = (element: ElementRef): Observable<boolean> => {
  return new Observable<IntersectionObserverEntry[]>((observer) => {
    const intersectionObserver = new IntersectionObserver((entries) => {
      observer.next(entries);
    });

    if (element?.nativeElement) {
      intersectionObserver.observe(element.nativeElement);
    }

    return () => {
      intersectionObserver.disconnect();
    };
  }).pipe(
    mergeMap((entries: IntersectionObserverEntry[]) => entries),
    map((entry: IntersectionObserverEntry) => entry.isIntersecting),
    distinctUntilChanged()
  );
};
